import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import { APP_NAME, APP_BUILD_NUMBER } from '../config/appInfo';
import { useThemeMode } from '../theme/ThemeModeContext';
import { lightTokens, darkTokens, accent } from '../theme/tokens';

const AuthShell = ({ children, maxWidth = 'sm' }) => {
  const { mode } = useThemeMode();
  const isDark = mode === 'dark';

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        background: isDark
          ? `linear-gradient(135deg, ${darkTokens.bg} 0%, ${darkTokens.surface} 50%, ${accent.main} 100%)`
          : `linear-gradient(135deg, ${lightTokens.panel} 0%, #1a4060 50%, ${accent.main} 100%)`
      }}
    >
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          px: 2,
          py: 4
        }}
      >
        <Container maxWidth={maxWidth}>{children}</Container>
      </Box>

      <Typography
        component="footer"
        variant="caption"
        sx={{
          py: 2,
          textAlign: 'center',
          color: isDark ? 'rgba(255,255,255,0.55)' : 'rgba(255,255,255,0.75)',
          letterSpacing: '0.02em'
        }}
      >
        {APP_NAME} · Build {APP_BUILD_NUMBER}
      </Typography>
    </Box>
  );
};

export default AuthShell;
